import React from 'react';
import { Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Dependés 100% del boca en boca',
    with: 'Sabés exactamente cómo comunicar tu trabajo'
  }, {
    without: 'No sabés qué publicar ni cuándo',
    with: 'Generás confianza antes del primer contacto'
  }, {
    without: 'No tenés estrategia de crecimiento',
    with: 'Atraés pacientes que ya están alineados contigo'
  }, {
    without: 'Tu agenda es impredecible',
    with: 'Tu presencia profesional trabaja por vos'
  }, {
    without: 'Invertís en formación pero no en visibilidad',
    with: 'Construís una consulta ética, estable y escalable'
  }];
  return <Section data-id="element-26">
      <div className="text-center mb-12" data-id="element-27">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-violetDark mb-4" data-id="element-28">
          MARKETING CONSCIENTE PARA TERAPEUTAS™
        </h2>
        <p className="text-brand-text/80 text-sm md:text-base max-w-2xl mx-auto" data-id="element-29">
          Organizar tu consulta es solo la mitad del camino. La otra mitad es
          que más personas descubran tu trabajo.
        </p>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-30">
        <div className="hidden md:block" data-id="element-31">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-32">
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-33">
              ❌ SIN MARKETING CONSCIENTE
            </div>
            <div className="font-serif font-bold text-lg text-brand-violet" data-id="element-34">
              ✅ CON MARKETING CONSCIENTE
            </div>
          </div>
          <div className="space-y-3" data-id="element-35">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-36">
                <div className="text-sm font-medium text-brand-burgundy/90 pr-4" data-id="element-37">
                  {row.without}
                </div>
                <div className="text-sm text-brand-violet font-medium" data-id="element-38">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Mobile View */}
        <div className="md:hidden space-y-4" data-id="element-39">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70" data-id="element-40">
              <div className="text-sm text-brand-burgundy/90 mb-2" data-id="element-41">
                ❌ {row.without}
              </div>
              <div className="text-sm text-brand-violet font-medium" data-id="element-42">
                ✅ {row.with}
              </div>
            </div>)}
        </div>
      </div>

      <div className="text-center mt-10" data-id="element-43">
        <p className="text-lg md:text-2xl font-display italic font-[600] text-brand-violetDark" data-id="element-44">
          💡 Un solo paciente nuevo puede recuperar la inversión completa. Y
          este sistema te enseña a atraer muchos más.
        </p>
      </div>
    </Section>;
};